@import '../../shared/frame';

.slide {
  overflow: hidden;
  font-size: 100px !important;
  font-weight: 900 !important;
  line-height: 1.1 !important;
}

.cover {
  object-fit: cover;
  background-color: #323A44;
}

.fg {
  padding: 3em;
}

.animation--fade-in {
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  animation-name: animate--fade-in;
}

@keyframes animate--fade-in {
  100% {
    transform: scale(1.5);
  }
}
